import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "@material-ui/core";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { DialogContent } from "@material-ui/core";
import { Tooltip, withStyles } from '@material-ui/core';
import { useDataProvider } from "../../api/DataProvider";

import "../../styles/devices/mob_SignDialog.css";
import { useTranslation } from "react-i18next";


import { formatDurationHourMinuteSecond } from '../../api/utils/strings';

import { pDialogVersusMachineRanking } from "../../utils/parameters";

import { RankingSuccess2 } from "../../utils/icons";
import { RankingSuccess3 } from "../../utils/icons";
import { RankingSuccess4 } from "../../utils/icons";
import { RankingSuccess5 } from "../../utils/icons";
import { RankingSuccess6 } from "../../utils/icons";



const DATA_IN_EXAMPLE = {
  'personal_score':{
    'user_id': '',
    'hits': 0,
    'perfectScore': 0,
    'timePerfectScore': 0,
  },
  'ranking':{
    'hits':[
    ],
    'perfectScore':[
    ],
    'timePerfectScore':[
    ]
  }
}

export default function DialogRanking(props) {
  const { t } = useTranslation("global")

  const { elements_requested, elements_response, server_report_activity } = props;
  const { json_data_USER } = useDataProvider();

  const [ rankingTabValue, setRankingTabValue ] = useState(0);
  const [ rankingData, setRankingData ] = useState(DATA_IN_EXAMPLE);

  useEffect(() => {
    // console.log('server_report_activity', server_report_activity)
    if (server_report_activity['personal_score'] !== undefined) {
      setRankingData(server_report_activity)
      // console.log(json_data_USER.profile.isPublic)
    }
  },[server_report_activity]);    

  return (
    <>
      <div>
        {/* <div className="sig_SignModal_VideoContainer" style={{ marginLeft: '40px'}}>
          <TableContainer style={{width: '400px'}} component={Paper}> */}
        <Tabs
            className="sig_VersusMachine_Ranking_Tabs"
            TabIndicatorProps={{ style: {'backgroundColor': '#f84848'}}}
            value={rankingTabValue}
            onChange={(event, newValue) => {
              setRankingTabValue(newValue);
            }}
            indicatorColor="primary"
            textColor="secondary"
            variant="fullWidth"
            centered
          >
            <Tab icon={<RankingSuccess4/>} className="sig_VersusMachine_Ranking_Tab" label="Aciertos"/>
            <Tab icon={<RankingSuccess5/>} className="sig_VersusMachine_Ranking_Tab" label="Plenos"/>
            <Tab icon={<RankingSuccess6/>} className="sig_VersusMachine_Ranking_Tab" label="Velocidad"/>
        </Tabs>
        <div className="sig_VersusMachine_TopTableContainer">
          <TableContainer className="sig_VersusMachine_TopRankingContainer" components={{Container: props => <Paper {...props} elevation={0}/>}}>
            {rankingTabValue === pDialogVersusMachineRanking.hitsRanking ?
            (
              <Table className="custom-table" aria-label="customized table">
                <TableHead >
                  <TableRow>
                    <TableCell className="table-header" align="center"> Usuario </TableCell>
                    <TableCell className="table-header" align="center"> Aciertos </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rankingData.ranking.hits.map(( item, index) => {

                    const rowStyle = {
                      backgroundColor: item['user_id'] === rankingData['personal_score']['user_id'] ? '#D3E9F9' : 'transparent',
                    };
                    const cellStyle = {
                      fontWeight: item['user_id'] === rankingData['personal_score']['user_id'] ? 'bold' : 'normal',
                    };
                    return (
                        <TableRow key={index} style={rowStyle}>
                          <TableCell className="table-cell" align="center"  style={cellStyle} >{item['user_id']}</TableCell>
                          <TableCell className="table-cell" align="center"  style={cellStyle}> {item['score']} </TableCell>
                        </TableRow>
                        )
                      })
                    }
                </TableBody>
              </Table>              
            )
            : <></>}

            {rankingTabValue === pDialogVersusMachineRanking.perfectScoreRanking ? 
            (
              <Table className="custom-table" aria-label="customized table">
                <TableHead >
                  <TableRow>
                    <TableCell className="table-header" align="center"> Usuario </TableCell>
                    <TableCell className="table-header" align="center"> Plenos </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                    {rankingData.ranking.perfectScore.map(( item, index) => {

                      const rowStyle = {
                        backgroundColor: item['user_id'] === rankingData['personal_score']['user_id'] ? '#D3E9F9' : 'transparent',
                      };
                      const cellStyle = {
                        fontWeight: item['user_id'] === rankingData['personal_score']['user_id'] ? 'bold' : 'normal',
                      };
                      return (
                          <TableRow key={index} style={rowStyle}>
                            <TableCell className="table-cell" align="center"  style={cellStyle} >{item['user_id']}</TableCell>
                            <TableCell className="table-cell" align="center"  style={cellStyle}> {item['score']} </TableCell>
                          </TableRow>
                          )
                        })
                      }
                  </TableBody>
              </Table>            
            ) 
            : <></>}

            {rankingTabValue === pDialogVersusMachineRanking.timePerfectScoreRanking ?
            (
              <Table className="custom-table" aria-label="customized table">
                <TableHead >
                  <TableRow>
                    <TableCell className="table-header" align="center"> Usuario </TableCell>
                    <TableCell className="table-header" align="center"> Tiempo </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                    {rankingData.ranking.timePerfectScore.map(( item, index) => {

                      const rowStyle = {
                        backgroundColor: item['user_id'] === rankingData['personal_score']['user_id'] ? '#D3E9F9' : 'transparent',
                      };
                      const cellStyle = {
                        fontWeight: item['user_id'] === rankingData['personal_score']['user_id'] ? 'bold' : 'normal',
                      };
                      return (
                          <TableRow key={index} style={rowStyle}>
                            <TableCell className="table-cell" align="center"  style={cellStyle} >{item['user_id']}</TableCell>
                            <TableCell className="table-cell" align="center"  style={cellStyle}> {formatDurationHourMinuteSecond(item['score'])} </TableCell>
                          </TableRow>
                          )
                        })
                      }
                  </TableBody>
              </Table>            
            )  
            : <></>}

          </TableContainer>
        </div>
        <br/>
        <div className="sig_VersusMachine_TopTableContainer">
          <TableContainer components={{Container: props => <Paper {...props} elevation={0}/>}}>
          <Table className="custom-table" aria-label="customized table">
          <TableHead>
              <TableRow>
                <TableCell className="table-header" colSpan={2} align="center"> {t("sRanking.personal_score").toUpperCase()} </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>

                {json_data_USER.profile.isPublic ? (
                  <TableCell className="table-cell2" colSpan={2} align="center"> <strong>{json_data_USER['profile']['name']}</strong> </TableCell>
                ) : (
                  
                  <Tooltip 
                    classes={{arrow: "sig_CustomTooltip_Arrow", tooltip: "sig_CustomTooltip_Container"}}
                    placement="bottom"
                    arrow
                    interactive={true} 
                    title={
                      <div className="sig_CustomTooltip_Content">
                        <p><strong> {t("sProfile.account_private")} </strong></p>
                        <p> {t("sProfile.account_set_to_public")} </p>
                      </div>
                    }>
                    <TableCell style={{backgroundColor: '#f7e70063'}} className="table-cell2" colSpan={2} align="center"> <strong>{rankingData['personal_score']['user_id']}</strong> </TableCell>
                  </Tooltip>
                  
                )}
              </TableRow>
              <TableRow>
                <TableCell className="table-cell"> <strong> {t("sRanking.number_hits")} </strong> </TableCell>
                <TableCell className="table-cell" align="center"> {rankingData['personal_score']['hits']} </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="table-cell"> <strong> {t("sRanking.number_full")} </strong> </TableCell>
                <TableCell className="table-cell" align="center"> {rankingData['personal_score']['perfectScore']} </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="table-cell"> <strong> {t("sRanking.time_min_full")} </strong> </TableCell>
                <TableCell className="table-cell" align="center"> {formatDurationHourMinuteSecond(rankingData['personal_score']['timePerfectScore'])}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
          </TableContainer>
        </div>
      </div>
    </>
  );
}